import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'

/**
 * @typedef {Object} ElectricVehicleBatteryCapacityOptions
 *
 * @property {string} objectId - The object id unique identifier
 * @property {array} options - The array with battery capacities [in kWh]
 */
export const electricVehicleBatteryCapacityOptionsPropType = PropTypes.shape({
    objectId: idPropType.isRequired,
    options: PropTypes.arrayOf(PropTypes.number)
})
